export const SELECTOR = 'district-map';
export const MAPBOX_TOKEN =
  'pk.eyJ1IjoidGV4YXN0cmlidW5lIiwiYSI6ImNqcGtjN2MxdTAxcTM0M21ybHB1c2xuMGcifQ.A9zqCHIg-me4HMP6bp7RPA';
